import React from 'react';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import Content from 'Views/Page/Content/Templates/WizardTemplates/WizardAttachmentsTemplate/Content/Content';

const ContentWithContext = (props) => {
  const {
    setModalCollection,
    refreshModalCollection,
  } = useModalContext();

  return <Content {...props} setCollection={setModalCollection} refreshCollection={refreshModalCollection} />;
};

export default ContentWithContext;
